import { Component, OnInit, Injector } from '@angular/core';
import { UntypedFormGroup, FormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { ServiceRequestService } from 'src/app/shared/service-request.service';
import { FileUploadComponent } from 'src/app/out-of-application/file-upload/file-upload.component';
import { MailTemplateComponent } from 'src/app/out-of-application/mail-template/mail-template.component';
import { getDate } from 'ngx-bootstrap/chronos/utils/date-getters';
import saveAs from 'file-saver';

@Component({
  selector: 'app-my-service-request',
  templateUrl: './my-service-request.component.html',
  styleUrls: ['./my-service-request.component.scss']
})
export class MyServiceRequestComponent implements OnInit {

  ServiceRequestForm: UntypedFormGroup;
  ServiceRequestLogDetail: UntypedFormGroup;
  requesterList: any;
  locationList: any;
  categoryList: any;
  subcategoryList: any;
  statusList: any;
  priorityList: any;
  itemList: any;
  filterList: any;
  IsVisisble: false;
  detailedPath: any;
  ServiceRequestLogDetailList: any;
  assingmentGroupList: any;
  assignedToList: any;
  ID: string;
  IsTypeWiseVisibility: boolean;
  IsButtonHide = true;
  IsButtonHideReOpen = false;

  constructor(private _fb: UntypedFormBuilder, private _router: Router, private error: AppErrorHandler,
    private _activeRoute: ActivatedRoute, public _commonService: CommonService,
    injector: Injector, private _dialog: MatDialog,
    private status: HTTPStatus, private _serviceRequestService: ServiceRequestService) { }

  ngOnInit() {
    /*****************************GetData By QueryString*************************/
    this.ID = this._activeRoute.snapshot.paramMap.get('ID');
    /**************************************End**********************************/
    this.ServiceRequestForm = this._fb.group({
      RequestEntityId: [''],
      RequisitionDate: [new Date()],
      RequestedforHead: ['', [Validators.required]],
      RequestedFor: [],
      RequestedForGPN: [],
      RequestedForCUG: [, [Validators.required]],
      ShortDescription: ['', [Validators.required]],
      LongDescription: ['', [Validators.required]],
      RequesterName: [],
      RequesterHead: [, [Validators.required]],
      RequestedBy: [],
      RequestedByGPN: [],
      RequestedByCUG: [],
      CategoryId: ['', [Validators.required]],
      Category: [],
      SubCategoryId: ['', [Validators.required]],
      SubCategory: [],
      ItemId: ['', [Validators.required]],
      Item: [],
      ReqLocation: ['', [Validators.required]],
      Location: [],
      StatusID: [],
      StatusName: [],
      PriorityID: [],
      Priority: [],
      IsRequestedFor: false,
      SRNumber: [],
      AssignmentGroupID: [''],
      AssignmentGroup: [],
      AdditionalComment: [],
      AssignedTo: [],
      AssignedToName: [],
      AssignedEmp: [],
      RequestedForName: [],
      CreatedOn: [] //anmol

    });
    this.ServiceRequestLogDetail = this._fb.group({
      RequestEntityId: [],
      SRID: [],
      Type: [],
      LogText: [],
      MailTo: [],
      MailCC: [],
      MailBCC: [],
      CreatedBy: [],
      CreatedByName: [],
      CreatedOn: [],
      IPAddress: []

    })
    this.IsTypeWiseVisibility = false;
    this.BindCategoryList();
    this.BindLocationList();
    this.BindStatusList();
    this.BindPriorityList();
    this.GetServiceRequestDetailByID(this.ID);

  }
  BindCategoryList() {
    this._commonService.BindDropDown('category').subscribe(result => {
      this.categoryList = result;
    });
  }
  BindLocationList() {
    this._commonService.BindDropDown('location').subscribe(result => {
      this.locationList = result;
    });
  }
  BindStatusList() {
    this._commonService.BindDropDown('Status').subscribe(result => {
      this.statusList = result;
    });
  }
  BindPriorityList() {
    this._commonService.BindDropDown('priority').subscribe(result => {
      this.priorityList = result;
    });
  }

  GetSubCategoryName(event) {
    if (event.originalEvent !== undefined) {
      this.ServiceRequestForm.controls.Category.setValue(event.originalEvent.currentTarget.innerText);
    }
    this._commonService.BindDropDownWithParam('subcategory', event.value).subscribe(result => {
      this.subcategoryList = result;
    });
  }
  BindItemName(event) {
    if (event.originalEvent !== undefined) {
      this.ServiceRequestForm.controls.SubCategory.setValue(event.originalEvent.currentTarget.innerText);
    }
    this._commonService.BindDropDownWithParam('item', event.value).subscribe(result => {
      this.itemList = result;
    });
  }

  BindAssigmentGroup(event) {
    if (event.originalEvent !== undefined) {
      this.ServiceRequestForm.controls.Item.setValue(event.originalEvent.currentTarget.innerText);
    }
    this._commonService.BindDropDownWithParam('assigmentgroup', event.value).subscribe(result => {
      this.assingmentGroupList = result;
    });
  }
  GetAttachmentDetailByID(data : any ){
    if(!this.checkValueIsNullOrEmptyOrUndefined(data)){
      if(!this.checkValueIsNullOrEmptyOrUndefined(data.BlobId)){
        const attachmentData = { BlobId: data.BlobId  , AttachmentName: data.AttachmentName };
            this._serviceRequestService.PostDownload(attachmentData).subscribe(x => {
              const blob = new Blob([x], { type: 'application/octet-stream' });
              saveAs(blob, data.AttachmentName);
            },(error:any) => {

              console.log(error);
            });
      }
    }
  }
  checkValueIsNullOrEmptyOrUndefined(value: any) {
    if (value == null || value == undefined || value == "") {
      return true;
    }
    else {
      return false;
    }
  }
  GetServiceRequestDetailByID(ID: string) {
    
    this._serviceRequestService.GetServiceRequestDetailByID(ID).subscribe(data => {
      
      this.ServiceRequestForm.patchValue(data);
      console.log(data,'GetServiceRequestDetailByID');//anmol
      this.ServiceRequestForm.controls.CreatedOn.setValue(data.CreatedOn);//anmol
      console.log(this.ServiceRequestForm,'ServiceRequestForm patchValue');//anmol
      this.assignedToList = {
        EmployeeGPN: data.AssignedTo, EmployeeName: data.AssignedToName
      };
      this.requesterList = {
        EmployeeGPN: data.RequestedForGPN, EmployeeName: data.RequestedFor
      };
      this.ServiceRequestLogDetailList = data.srLogDetailList;
      this.ServiceRequestForm.controls.AssignedEmp.setValue(this.assignedToList);
      this.ServiceRequestForm.controls.ReqLocation.setValue(String(data.ReqLocation));
      this.ServiceRequestForm.controls.CategoryId.setValue(String(data.CategoryId));
      this.GetSubCategoryName(this.ServiceRequestForm.controls.CategoryId);
      this.ServiceRequestForm.controls.SubCategoryId.setValue(String(data.SubCategoryId));
      this.BindItemName(this.ServiceRequestForm.controls.SubCategoryId);
      this.ServiceRequestForm.controls.ItemId.setValue(String(data.ItemId));
      this.BindAssigmentGroup(this.ServiceRequestForm.controls.ItemId);
      this.ServiceRequestForm.controls.AssignmentGroupID.setValue(String(data.AssignmentGroupID));
      this.ServiceRequestForm.controls.AssignmentGroup.setValue(String(data.AssignmentGroup));
      this.ServiceRequestForm.controls.StatusID.setValue(String(data.StatusID));
      this.ServiceRequestForm.controls.AdditionalComment.setValue(String(data.AdditionalComment));
      this.ServiceRequestForm.controls.PriorityID.setValue(String(data.PriorityID));
      this.ServiceRequestForm.controls.AssignedTo.setValue(String(data.AssignedTo));
      this.ServiceRequestForm.controls.AssignedToName.setValue(String(data.AssignedToName));
      this.ServiceRequestForm.controls.ShortDescription.setValue(String(data.ShortDescription));
      this.ServiceRequestForm.controls.LongDescription.setValue(data.LongDescription);

      this.ServiceRequestForm.controls.SRNumber.setValue(data.SRNumber);
      this.ServiceRequestForm.controls.RequestedBy.setValue(data.RequestedBy);
      this.ServiceRequestForm.controls.RequestedByGPN.setValue(data.RequestedByGPN);
      this.ServiceRequestForm.controls.RequestedByCUG.setValue(data.RequestedByCUG);
      this.ServiceRequestForm.controls.RequestedforHead.setValue(this.requesterList);
      this.ServiceRequestForm.controls.RequestedForGPN.setValue(data.RequestedForGPN);
      this.ServiceRequestForm.controls.RequestedForName.setValue(data.RequestedForName);
      this.ServiceRequestForm.controls.RequestedForCUG.setValue(data.RequestedForCUG);
      this.ServiceRequestForm.controls.IsRequestedFor.setValue(data.IsRequestedFor);
      if (String(data.StatusID) == "4" || String(data.StatusID) == "5") {
        this.IsButtonHide = false;
      } else {
        this.IsButtonHide = true;
      }
      if (String(data.StatusID) == "4" && Boolean(data.IsAvaiForReOpen) === true) {
        this.IsButtonHideReOpen = true;
      } else {
        this.IsButtonHideReOpen = false;
      }
    }, (error) => {
      // this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => {
      //this.status.setHttpStatus(false); 
    });
  }

  openFileUploadDialog() {
    this._dialog.open(FileUploadComponent,
      {
        disableClose: true,
        height: '400px',
        width: '600px',
        data: { ID: this.ID, AttachmentFor: "ServiceRequest", StatusID: this.ServiceRequestForm.controls.StatusID.value }
      });
  }
  openMailTemplateDialog() {
    this._dialog.open(MailTemplateComponent,
      {
        disableClose: true,
        width: '70%',
        data: { ID: this.ID }

      });
  }
  SearchActiveEmployee = (event) => {
    this._serviceRequestService.GetAssigmentToEmployee('FillCommonData/GetEmployeeForAssignedTo', event.query, this.ServiceRequestForm.controls.AssignmentGroupID.value).subscribe(result => {
      this.assignedToList = this.filterDataList(event.query, result);
    }, (error) => {
      this.error.handleError(error);
    }, () => {
    });
  }

  filterDataList(query, dataList: any): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      this.filterList = dataList[i];
      if (this.filterList.EmployeeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(this.filterList);
      }
    }
    return filtered;
  }
  SetEmployeeDetails(event) {
    this.ServiceRequestForm.patchValue({
      AssignedTo: event.EmployeeGPN,
      AssignedToName: event.EmployeeName,

    })

  }
  clearAutoComplete(controlname) {


    this.ServiceRequestForm.controls.AssignedTo.reset();
    this.ServiceRequestForm.controls.AssignedToName.reset();

  }
  UpdateSR() {

    this.status.setHttpStatus(true);
    this.ServiceRequestForm.controls.RequestEntityId.setValue(this.ID);
    this._serviceRequestService.UpdateServiceRequest(this.ServiceRequestForm.value).subscribe(data => {
      if (data.RequestIsSuccess) {
        if (data.RequestEntityId !== null) {
          alert(data.RequestMessage);
          this.GetServiceRequestDetailByID(this.ID);
        }
      } else {
        alert(data.RequestMessage);
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  GetStatusName(event) {
    if (event.originalEvent !== undefined) {
      this.ServiceRequestForm.controls.StatusName.setValue(event.originalEvent.currentTarget.innerText);
    } else {
      const statusList = this.statusList.filter(x => x.value === event.value);
      this.ServiceRequestForm.controls.StatusName.setValue(statusList[0].label);
    }
  }
  GetpriorityName(event) {
    if (event.originalEvent !== undefined) {
      this.ServiceRequestForm.controls.Priority.setValue(event.originalEvent.currentTarget.innerText);
    } else {
      const priorityList = this.priorityList.filter(x => x.value === event.value);
      this.ServiceRequestForm.controls.Priority.setValue(this.priorityList[0].label);
    }
  }
}

